import { FieldModel } from '@cibo/core'
import { Stack, Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import {
  AmendmentCell,
  BiomassBurningCell,
  CashCropCell,
  CoverCropCell,
  FertilizerCell,
  IrrigationCell,
  LimingCell,
  LivestockCell,
  NaturalDisturbanceCell,
  TillageCell,
  WaterPumpIrrigationCell,
} from './TraitCells'

interface TaskEditorTableCellProps extends GridRenderCellParams {
  row: {
    traitId: string
    [key: string]: any
  }
  task: any
  selectedField: FieldModel | null
}

export const TaskEditorTableCell = (props: TaskEditorTableCellProps) => {
  const { row, value, field: year, task, selectedField } = props
  const { traitId } = row
  switch (traitId) {
    case 'naturalDisturbance':
      return (
        <NaturalDisturbanceCell
          value={value}
          task={task}
          selectedField={selectedField}
          year={+year}
        />
      )
    case 'waterPumpIrrigation':
      return (
        <WaterPumpIrrigationCell
          value={value}
          task={task}
          selectedField={selectedField}
          year={+year}
        />
      )
    case 'cashCrop':
      return <CashCropCell value={value} task={task} selectedField={selectedField} year={+year} />
    case 'tillage':
      return <TillageCell value={value} task={task} selectedField={selectedField} year={+year} />
    case 'coverCrop':
      return <CoverCropCell value={value} task={task} selectedField={selectedField} year={+year} />
    case 'biomassBurning':
      return (
        <BiomassBurningCell value={value} task={task} selectedField={selectedField} year={+year} />
      )
    case 'livestock':
      return <LivestockCell value={value} task={task} selectedField={selectedField} year={+year} />
    case 'fertilizer':
      return <FertilizerCell value={value} task={task} selectedField={selectedField} year={+year} />
    case 'amendment':
      return <AmendmentCell value={value} task={task} selectedField={selectedField} year={+year} />
    case 'irrigation':
      return <IrrigationCell value={value} task={task} selectedField={selectedField} year={+year} />
    case 'liming':
      return <LimingCell value={value} task={task} selectedField={selectedField} year={+year} />
    default:
      return (
        <Stack>
          <Typography>{JSON.stringify(value)}</Typography>
        </Stack>
      )
  }
}
